export default "__VITE_ASSET__yLaj0lPt__"